import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS, postData } from '../../constants/api';
import { Link } from 'react-router-dom';
import { updateColumn } from '../../constants/functions';
import ModalForm from '../../components/ModalForm';
import { decodeToken, getToken } from '../../utils/TokenUtils';

export default function PatientTabs({
  appointmentId,
  patientType = 'out',
  room = 'N/A',
}) {
  const isDisabled = patientType == 'in' && room == 'N/A';
  console.log(
    'appointmentId:',
    appointmentId,
    'patientType:',
    patientType,
    'room:',
    room
  );

  // console.log('aaa');
  const [sections, setSections] = useState([]);
  const [activeTab, setActiveTab] = useState('All');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentRoute, setCurrentRoute] = useState('');
  const [queryParams, setQueryParms] = useState('');
  const [isModalFormOpen, setIsModalFormOpen] = useState(false);

  const token = getToken();
  const user_id = decodeToken(token, 'id');

  useEffect(() => {
    if (!appointmentId) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/activityReport/test-Patient-History`;
        const body = { appointment_id: appointmentId };
        const response = await postData(url, body);
        console.log('body: 44444' , body, 'response.data: 444', response.data);
        const data = response.data || [];

        setSections(data);
      } catch (err) {
        setError('Failed to load data ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [appointmentId]);

  if (!appointmentId) return <p>Please select an appointment</p>;
  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  const renderFields = (fields) => {
  const { color, ...rest } = fields; // remove color
  return (
    <div className="row">
      {Object.entries(rest).map(([key, value]) => (
        <div key={key} className="col-md-12 mb-2"  style={{
              color: color ,
              
            }}>
          <strong
           
          >
            {key}:
          </strong>{" "}
          {value}
        </div>
      ))}
    </div>
  );
};


  // Extract id between two hashes: e.g. "abc#123#def" → 123
  const extractIdFromHash = (value) => {
    if (!value) return null;
    const matches = value.match(/#([^#]+)#/);
    return matches ? matches[1] : null;
  };
  const renderTable = (title, rows) => {
    if (!rows.length) {
      return (
        <div className="mb-4">
          <p>No records found.</p>
        </div>
      );
    }
    const cleanTitle = title.toLowerCase().replace(/\s+/g, '');

    // Extract column metadata
    const allKeys = Object.keys(rows[0]);
    const groupKey = allKeys.find((k) => k.endsWith('~group'));
    console.log('all keys',allKeys);
    console.log('Group Key',groupKey);
   
    const spanKeys = allKeys.filter((k) => k.endsWith('~span'));
    const visibleKeys = allKeys.filter((k) => !k.endsWith('~group'));

    // Clean column labels (remove ~group or ~span)
    const getCleanKey = (key) => key.split('~')[0];

    // Group rows if groupKey exists
    const groupedRows = groupKey
      ? rows.reduce((acc, row) => {
          const groupValue = row[groupKey];
          if (!acc[groupValue]) acc[groupValue] = [];
          acc[groupValue].push(row);
          return acc;
        }, {})
      : { [title || 'Data']: rows };
     console.log('Grouped rows',groupedRows)
    return (
      <div className="mb-4">
        {Object.entries(groupedRows).map(
          ([groupValue, groupRows], groupIdx) => {
            // For rowspan tracking
            const spanCountMap = {};
            spanKeys.forEach((spanKey) => {
              spanCountMap[spanKey] = {};
              let prev = null;
              groupRows.forEach((row, i) => {
                const val = row[spanKey];
                if (val === prev) {
                  spanCountMap[spanKey][i] = 0; // Skip
                  spanCountMap[spanKey][i - 1] =
                    (spanCountMap[spanKey][i - 1] || 1) + 1;
                } else {
                  spanCountMap[spanKey][i] = 1; // Initial
                }
                prev = val;
              });
            });

            return (
              <div key={groupIdx} className="mb-4">
                {/* {groupKey && (
                  <h5 className="mb-2">
                    {getCleanKey(groupKey)}: {groupValue} 
                  </h5>
                )} */}
                {groupKey &&
                  (() => {
                    const id = extractIdFromHash(groupValue); // created inside the check

                    return (
                      <div>
                        <h5 className="mb-2">
                          {getCleanKey(groupKey)}: {groupValue}
                        </h5>

                        {id && (
                          <div className="d-flex gap-2 mt-2">
                            <Link
                              className="btn btn-warning"
                              to={`/form-report/cancel-${cleanTitle}?id=${id}`}
                              isDisabled={true}
                            >
                              Update/Delete
                            </Link>
                           
                          </div>
                        )}
                      </div>
                    );
                  })()}
                <table className="table table-striped">
                  <thead>
                    <tr>
                      {visibleKeys.map((key) => (
                        <th key={key}>{getCleanKey(key)}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {groupRows.map((row, rowIndex) => (
                      <tr key={row.id || rowIndex}>
                        {visibleKeys.map((key, colIndex) => {
                          const value = row[key];
                          if (spanKeys.includes(key)) {
                            const span = spanCountMap[key][rowIndex];
                            if (span === 0) return null; // skip cell
                            return (
                              <td key={colIndex} rowSpan={span}>
                                {value}
                              </td>
                            );
                          }
                          return <td key={colIndex}>{value}</td>;
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          }
        )}
      </div>
    );
  };

  const renderSection = (section) => (
    <div key={section.title} className="mb-4">
      <h4>{section.title}</h4>
      {section.fields && renderFields(section.fields)}
      {Array.isArray(section.table) &&
        renderTable(section.title, section.table)}
    </div>
  );

  const openFormModal = (route, queryParams) => {
    setCurrentRoute(route);
    setQueryParms(queryParams);
    // setUpdateTable()
    setIsModalFormOpen(true);
  };
  const closeFormModal = () => {
    setIsModalFormOpen(false);
  };

  const href = `updatecolumn/caafi_appointment/${appointmentId}/type/${patientType === 'in' ? 'out' : 'in'}`;
  return (
    <div className="container p-3">
      <div className="mb-3">
        <Link
          className="btn btn-primary me-2"
          to={`/multi-entry/Presciption-Multi?appointment_id=${appointmentId}`}
          onClick={(e) => {
            if (isDisabled) {
              alert('Please first request to assign a bed');
              e.preventDefault(); // Disable navigation
            }
          }}
          title={`${isDisabled ? `First assign bed, Patient Type: -${patientType}-, Room: -${room}-` : ''}`}
          style={{
            color: isDisabled ? 'gray' : '',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          Prescription
        </Link>

        <Link
          className="btn btn-warning me-2"
          to={`/lab-test-request/doctor-lab-request/${appointmentId}`}
          onClick={(e) => {
            if (isDisabled) {
              alert('Please first request to assign a bed');
              e.preventDefault(); // Disable navigation
            }
          }}
          title={`${isDisabled ? `First assign bed, Patient Type: -${patientType}-, Room: -${room}-` : ''}`}
          style={{
            color: isDisabled ? 'gray' : '',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          Lab Request
        </Link>
        <Link
          className="btn btn-primary me-2"
          to={`/lab-test-request/doctor-image-request/${appointmentId}`}
          onClick={(e) => {
            if (isDisabled) {
              alert('Please first request to assign a bed');
              e.preventDefault(); // Disable navigation
            }
          }}
          title={`${isDisabled ? `First assign bed, Patient Type: -${patientType}-, Room: -${room}-` : ''}`}
          style={{
            color: isDisabled ? 'gray' : '',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          Image Request
        </Link>

        <button
          className={`btn btn-danger me-2`}
          onClick={(e) => updateColumn(e, href)}
        >
          {`Make ${patientType === 'in' ? 'out' : 'in'} patient`}
        </button>

        <button
          className="btn btn-success me-2"
          onClick={(e) =>
            openFormModal(
              'register-appointment_notes',
              'appointment_id=' + appointmentId
            )
          }
        >
          Doctor Notes
        </button>

        <button
          className="btn btn-danger me-2"
          onClick={(e) =>
            openFormModal(
              'referral-appointment',
              'appointment_id=' + appointmentId
            )
          }
        >
          Referral
        </button>

        <button
          className="btn btn-success me-2"
          onClick={(e) =>
            openFormModal(
              'register-caafi_doctor_consultation_request',
              'appointment_id=' + appointmentId
            )
          }
        >
          Request Consultation
        </button>

        <button
          className="btn btn-danger me-2"
          onClick={(e) =>
            openFormModal(
              'register-caafi_allergies_note',
              'appointment_id=' + appointmentId
            )
          }
        >
          Allergies Note
        </button>

        
        

        {isModalFormOpen && currentRoute && (
          <ModalForm
            userId={user_id}
            token={token}
            queryParams={queryParams}
            route={currentRoute} // Pass the dynamic route to the modal
            isOpen={isModalFormOpen}
            onRequestClose={closeFormModal}
          />
        )}
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'All' ? 'active' : ''}`}
            onClick={() => setActiveTab('All')}
            style={{'color':'blue',padding:'15px'}}
           
          >
            All
          </button>
        </li>
        {sections.map((section) => (
          <li key={section.title} className="nav-item" >
            <button
              className={`nav-link ${
                activeTab === section.title ? 'active' : ''
              }`}
              onClick={() => setActiveTab(section.title)}
              style={{'color':'blue',padding:'15px'}}
              
            >
              {section.title}
            </button>
          </li>
        ))}
      </ul>

      {/* Tab Content */}
      {activeTab === 'All'
        ? sections.map((section) => renderSection(section))
        : sections
            .filter((section) => section.title === activeTab)
            .map((section) => renderSection(section))}
    </div>
  );
}